import { render, staticRenderFns } from "./TheLoginLandingPage.vue?vue&type=template&id=bb8e2754&"
import script from "./TheLoginLandingPage.vue?vue&type=script&lang=js&"
export * from "./TheLoginLandingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports